var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.51001H18C20.2091 4.51001 22 6.30087 22 8.51001V12.77C22 14.9791 20.2091 16.77 18 16.77H6C3.79086 16.77 2 14.9791 2 12.77V8.51001C2 6.30087 3.79086 4.51001 6 4.51001ZM18 15.1C19.2868 15.1 20.33 14.0568 20.33 12.77V8.51001C20.33 7.22319 19.2868 6.18001 18 6.18001H6C4.71318 6.18001 3.67 7.22319 3.67 8.51001V12.77C3.67 14.0568 4.71318 15.1 6 15.1H18Z",
    fill: "#404A51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.74H6.5C6.08579 18.74 5.75 19.0758 5.75 19.49C5.75 19.9042 6.08579 20.24 6.5 20.24H17.5C17.9142 20.24 18.25 19.9042 18.25 19.49C18.25 19.0758 17.9142 18.74 17.5 18.74Z",
    fill: "#404A51"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/Tv.965e26877e53b5b98867bef97d0b401c.svg";
export { ForwardRef as ReactComponent };